import { render, staticRenderFns } from "@/client/budget/views/acceptance/choose-fees/choose-convocation/choose-convocation.pug?vue&type=template&id=5c3e291c&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/acceptance/choose-fees/choose-convocation/choose-convocation.scss?vue&type=style&index=0&id=5c3e291c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e291c",
  null
  
)

export default component.exports